import React from 'react';
import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Flex,
} from '@chakra-ui/react';
import { useGetRepairDetailsFromIdQuery } from '@spartalabs/pdc-core';
import { Loading } from 'components/Loading';
import parse from 'html-react-parser';

interface FgtPwModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}

export const DetailsModal = ({ isOpen, onClose, id }: FgtPwModalProps) => {
  const {
    data: details,
    isLoading,
    isFetching,
  } = useGetRepairDetailsFromIdQuery({ groupId: '157', id: id });

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={{ base: '80%', md: '716px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        <ModalHeader
          p="0px"
          fontSize="xl"
          fontWeight={800}
          color="black"
          alignSelf="start"
        >
          Solicitações do Usuário
        </ModalHeader>
        <ModalCloseButton bg="gray.200" borderRadius="36px" color="black" />

        {isLoading || isFetching ? (
          <Flex w="100%" h="100px" justify="center" align="center">
            <Loading />
          </Flex>
        ) : (
          <ModalBody py="0px " px="0px" textAlign="start">
            {details?.map((detail, index) => (
              <Text key={index} p="8px 0 0px 0" color="gray.300">
                {parse(detail)}
              </Text>
            ))}
          </ModalBody>
        )}

        <ModalFooter pb="0px">
          <Button variant="outline" onClick={onClose}>
            Voltar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
